export default __webpack_public_path__ + "static/media/compression-chiller.cbb94371.jpg";